const BASIC = 'BASIC'
const UPGRADING = 'UPGRADING'
const PREMIUM = 'PREMIUM'
const UPGRADE_ERROR = 'UPGRADE_ERROR'

export default Object.freeze({
    BASIC,
    UPGRADING,
    PREMIUM,
    UPGRADE_ERROR,
})
